/* mm-trio-highlight: <mm-trio-carousel> drives the swipeable photo carousel of sections/mm-trio-highlight.liquid.
   A scroll-snap track ([data-track], one photo per slide), dots ([data-dot]) that follow the scroll position, and
   prev/next buttons ([data-prev] / [data-next]) that wrap around at the ends. A custom element, so it re-initialises
   itself when the theme editor re-renders the section. */
(() => {
  if (customElements.get('mm-trio-carousel')) return;
  customElements.define('mm-trio-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.ac = new AbortController();
      const opts = { signal: this.ac.signal };
      this.index = 0;
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const count = () => this.track.children.length;
      this.go = (i) => {
        const n = count();
        if (!n) return;
        const to = (i + n) % n;
        this.track.scrollTo({ left: to * this.track.clientWidth, behavior: still ? 'auto' : 'smooth' });
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1), opts);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1), opts);
      this.track.addEventListener('scroll', () => {
        const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        if (i !== this.index) { this.index = i; this.paint(); }
      }, { passive: true, signal: this.ac.signal });
      this.paint();
    }
    paint() {
      this.dots.forEach((d, i) => d.classList.toggle('is-on', i === this.index));
      [...this.track.children].forEach((s, i) => s.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
    }
    disconnectedCallback() { this.ac?.abort(); }
  });
})();
